import { vault } from '../../actions/actionTypes';
const initialState = {
    home: [],
    mostRecent: [],
    search: [],
};
export default function (state = initialState, action) {
    switch (action.type) {
        case vault.FETCH_FILES_TREE:
            const fetchFilesPayload = action.payload;
            const keys = fetchFilesPayload.files.map((file) => file.uriKey);
            let folderId = fetchFilesPayload.folderId;
            if (fetchFilesPayload.isCameraUploads) {
                const numbers = state.home.filter((item) => /^\d+$/.test(item)).map(Number);
                folderId = Math.min(...numbers).toString();
            }
            const fileState = state[folderId] || [];
            if (fetchFilesPayload.refresh) {
                return { ...state, [folderId]: keys };
            }
            if (folderId === 'mostRecent') {
                return {
                    ...state,
                    [folderId]: [...new Set(keys.concat(fileState).slice(0, 8))],
                };
            }
            return {
                ...state,
                [folderId]: [...new Set(fileState.concat(keys))],
            };
        case vault.DELETE_FILE_TREE:
            const deleteFilePayload = action.payload;
            const parentId = state[deleteFilePayload.folderId] ? deleteFilePayload.folderId : 'home';
            return {
                ...state,
                [parentId]: state[parentId].filter((uriKey) => uriKey !== deleteFilePayload.uriKey),
            };
        case vault.MOVE_FILE:
            const moveFilePayload = action.payload;
            const sourceId = state[moveFilePayload.sourceFolderId] ? moveFilePayload.sourceFolderId : 'home';
            const destinationFolder = state[moveFilePayload.destinationFolderId] || state.home;
            destinationFolder.push(moveFilePayload.file.uriKey);
            return {
                ...state,
                [sourceId]: state[sourceId].filter((uriKey) => uriKey !== moveFilePayload.file.uriKey),
            };
        case vault.LOGOUT_FILES_TREE:
            return initialState;
        default:
            return state;
    }
}
